export default "__VITE_ASSET__f$Yg1jiY__"